import cookie from 'react-cookies';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { redirectToChangeAgreementPage } from '@r1-frontend/entities/stores/auth/helpers/redirectToChangeAgreementPage';
import { TState } from '@r1-frontend/entities/stores/auth/reducer';

import { ACCESS_TOKEN_COOKIE } from '@r1-frontend/shared/constants';
import { USER_CHANGE_AGREEMENT_ROUTE } from '@r1-frontend/shared/constants/routes';

export const verifyAuthState = (isSso: () => boolean) => {
    return (_: ThunkDispatch<TState, void, AnyAction>, getState: () => TState) => {
        const state = getState();
        if (state.auth.isAuth) {
            const accessToken = cookie.load(ACCESS_TOKEN_COOKIE);
            const isAccessTokenDefined = Boolean(accessToken);

            if (!isAccessTokenDefined) {
                if (isSso()) {
                    return window.location.replace(
                        `${USER_CHANGE_AGREEMENT_ROUTE}?referrer=${document.location.pathname}`,
                    );
                }

                redirectToChangeAgreementPage();
            }
        }
    };
};
